import { render } from "./IBubbleColor.vue?vue&type=template&id=460ea15b"
import script from "./IBubbleColor.vue?vue&type=script&lang=js"
export * from "./IBubbleColor.vue?vue&type=script&lang=js"

import "./IBubbleColor.vue?vue&type=style&index=0&id=460ea15b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__